import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
  CarUnderHoodInspectionForm,
  CarUnderHoodInspectionFormValues,
  Header,
} from '~/entities/Inspection'
import { goToNextStep } from '../stepModel'

type CarUnderHoodInspectionStepProps = {
  form: UseFormReturn<CarUnderHoodInspectionFormValues>
}

export function CarUnderHoodInspectionStep({
  form,
}: CarUnderHoodInspectionStepProps) {
  const { t } = useTranslation()
  const onSuccess = () => {
    goToNextStep()
  }

  return (
    <>
      <Header title={t('under the hood inspection')} />

      <CarUnderHoodInspectionForm onSuccess={onSuccess} form={form} />
    </>
  )
}
